/**
 * 通讯录通用组件
 * @author sunzhiguang
 * @date 2020/9/11
 */

import React, { ReactNode } from "react";
import { AddressNavKey } from "@/types/common";
import IconFont, { IconDefualtOrg, IconDefualtWorkLine } from "@/components/icon";
import { useTranslation } from "react-i18next";
import {
  UserCardType,
  UserCardAction,
  TitleDeptInfo,
  userDetailListPrams,
  UserCardItem
} from "@/types/UserCard";
import Bus from "@/utils/bus";
import { Apply, Employee, Friend, RosterApplyStatus, UID } from "@/types/chat";
import {
  EBookDeptInfoRes,
  EBookDeptUserInfo,
  EBookSubDeptInfo,
  Project,
  SimpleDeptInfo
} from "@/models/ebook";
import { getHeadImgThumbUrl } from "@/utils/chat/index";
import ImService from "@/server/ImService";
import { Button, message } from "antd";
import { EGroupGroupInfo } from "@/api/egroup";
import i18n from "@/i18n";
import { v4 } from "uuid";
import { getDeptPositionDesc } from "@/models/user";
import { getEbookOrgInfo } from "@/api/ebook";
import icon_jzb from "@/assets/img/icon-jzb.png";
import default_dept_avatar from "@/assets/img/default_dept_avatar.png";
import default_virtual_avatar from "@/assets/img/default_virtual_avatar.png";
import { last, omitBy, isEmpty, debounce } from "lodash";
import { gatewayInstance } from "@/server/gateway";
import { ListItemData, labelInfoList } from "@jd/focus-desktop-comps/lib/es/ListItem";
import { createCloudLinkCall, createCloudLinkTerminalCall } from "../MeetingCloudLink/utils";
import logger from "@/utils/logger";
import { changeEgovUrl } from "@/utils/tools";
import { getBigScreenMeetingTopic, createMeeting } from "@/baseComponents/Meeting/utils";
import EmployeeLabel from "@jd/jdee.im.sdk/lib/es/model/EmployeeLabel";
import { setUserTypeChange } from "../Tags";
import { AVSDK } from "@/baseComponents/Meeting/common";

import {
  EmplListInfo,
  NodeListInfo,
  ebookWorkLineInfo
} from "@jd/jdee.im.sdk/lib/es/model/WorkLine";
import { GetEbookWorkLineReq } from "@jd/jdee.im.sdk/lib/es/service/WorkLine";
export function mapResultUsers(
  rosters: Partial<ListItemData>[],
  opts?: { checked?: boolean; visible?: boolean }
): ListItemData[] {
  return rosters.map((roster) => {
    return {
      ...roster,
      id: `${roster.userId}:${roster.app}:${roster.teamId}`,
      name: roster?.name,
      avatar: roster?.avatar,
      checked: opts?.checked || false,
      userId: roster?.userId,
      teamId: roster?.teamId,
      visible: opts?.visible || false
    };
  });
}
const log = logger.getLogger("addressBook");

export const manageMenus = [
  {
    id: AddressNavKey.MANAGE_EXTERNAL,
    label: "nav.manage_external",
    avatar: <IconFont className="address-contacts-icon-color" type="iconwaibulianxiren" />
    // clstag: "pageclick|keycount|xtbg_add_home_1637657110163|4"
  },
  {
    id: AddressNavKey.PUBLIC_ACCOUNT,
    label: "nav.public_account",
    avatar: <IconFont className="address-contacts-icon-color" type="icongonggongzhanghao" />
    // clstag: "pageclick|keycount|xtbg_add_home_1637657110163|4"
  }
];

export const subMenuItems = [
  {
    id: AddressNavKey.BROADCAST,
    label: "nav.broadcast",
    avatar: <IconFont className="address-contacts-icon-color" type="iconguangbohao" />
  }
];
// 菜单配置
export const menuItems = [
  {
    id: AddressNavKey.NEW_CONTACTS,
    label: "nav.new_contacts",
    avatar: <IconFont className="address-contacts-icon-color" type="iconxindeshenqing" />,
    clstag: "pageclick|keycount|xtbg_add_home_1637657110163|4"
  },
  {
    id: AddressNavKey.EXTERNAL_CONTACTS,
    label: "nav.external_contacts",
    avatar: <IconFont className="address-contacts-icon-color" type="iconwodelianxiren" />,
    clstag: "pageclick|keycount|xtbg_add_home_1637657110163|5"
  },
  // {
  //     id: AddressNavKey.SPECIAL_PROJECTS,
  //     label: 'nav.my_projects',
  //     avatar: <IconFont className="address-group-icon-color" type="iconzw_app_project" />,
  //     clstag: 'pageclick|keycount|focus_contacts_01_1615797764654|4',
  // },
  {
    id: AddressNavKey.GROUP,
    label: "nav.group",
    avatar: <IconFont className="address-group-icon-color" type="iconwodezu" />,
    clstag: "pageclick|keycount|xtbg_add_home_1637657110163|6"
  },
  {
    id: AddressNavKey.TAG,
    label: "nav.tag",
    avatar: <IconFont className="address-labels-icon-color" type="iconfenzu" />,
    clstag: "pageclick|keycount|xtbg_address_home_1722323222167|1"
  }
  // {
  //     id: AddressNavKey.ORG,
  //     label: 'nav.org',
  //     avatar: <IconFont className="address-org-icon-color" type="iconzuzhijiagou" />,
  // },
  // {
  //     id: AddressNavKey.MY_DEPARTMENT,
  //     label: 'nav.my_department',
  //     avatar: <IconFont className="address-my-department-icon-color" type="iconwodebumen" />,
  //     clstag: 'pageclick|keycount|xtbg_add_home_1637657110163|7',

  // },
  // {
  //     id: AddressNavKey.ADD_EXTERNAL_CONTACTS_GROUP,
  //     label: 'nav.add_external_contacts_group',
  //     avatar: <IconFont className="address-add-contacts-icon" type="iconic_shared" />,
  // },
];

export function handleCreateGroupXCMeeting(dataList: any[], memberType?: number) {
  log.debug("信创视频会议", dataList, memberType);
  if (memberType === 1) {
    createMeeting(
      AVSDK.HUAWEI,
      {
        topic: getBigScreenMeetingTopic()
      },
      dataList.map((r) => ({
        name: r.name,
        pin: r.userId,
        teamId: r.teamId,
        app: r.appId,
        avatar: r.avatar as string
      }))
    ).catch((err) => {
      message.error(err.message || err);
    });
    return;
  } else if (memberType === 2) {
    createCloudLinkTerminalCall([dataList[0].terminalId], getBigScreenMeetingTopic()).catch(
      (err) => {
        message.error(err.message || err || "会议创建失败");
      }
    );
    return;
  }

  const users = dataList?.filter((item: any) => item.memberType === 1) || [];
  const terminalIds = dataList?.filter((item: any) => item.memberType === 2) || [];
  const toUsers = users.map((item) => {
    return {
      teamId: item?.teamId,
      userId: item?.userId,
      appId: item?.appId || item?.app,
      userName: item?.fields?.filter((item: any) => item.key === "name")[0].val,
      avatar: item?.fields?.filter((item: any) => item.key === "avatar")[0].val
    };
  });
  const terminals: any[] = terminalIds.map((item: any) => {
    return {
      terminalId: item?.terminalId
    };
  });
  log.debug(toUsers, { terminalId: terminals }, "terminalsterminalsterminals");
  createCloudLinkCall({
    toUsers: toUsers,
    terminals: { terminalId: terminals },
    opts: { meetingTopic: getBigScreenMeetingTopic() }
  }).catch((err) => {
    message.error(err.message || err || "会议创建失败");
  });
}

// 头
export function ContentHeader({
  title,
  handleSwitchClick,
  activeKey,
  extra,
  extraClick,
  extraManageExternalClick,
  TabSwitchNode,
  deptNavigation,
  creatMeeting,
  bigScreenTitle = false
}: {
  title: string;
  handleSwitchClick?: (key: string) => void;
  activeKey?: string;
  extra?: string;
  extraClick?: () => void;
  extraManageExternalClick?: () => void;
  TabSwitchNode?: ReactNode;
  deptNavigation?: any;
  creatMeeting?: ReactNode;
  bigScreenTitle?: boolean;
}) {
  const { t } = useTranslation("addressList");
  const [t_common] = useTranslation("common");
  const fileBtnClsTag = (extra: string): { btnIcon?: any; btnName: string; clstag: string } => {
    switch (extra) {
      case t("nav.new_contacts"):
        return {
          btnName: t_common("createButton.addContact"),
          clstag: "pageclick|keycount|xtbg_add_home_1637657110163|10"
        };
      case t("nav.external_contacts"):
        return {
          btnName: t_common("createButton.addContact"),
          clstag: "pageclick|keycount|xtbg_add_home_1637657110163|13"
        };
      case t("nav.group"):
        return {
          btnName: t_common("createButton.createGroup"),
          clstag: "pageclick|keycount|xtbg_add_home_1637657110163|15"
        };
      case t("nav.tile"):
        return {
          btnIcon: "iconapp_ic_Quicklist",
          btnName: t("nav.tile"),
          clstag: "pageclick|keycount|xtbg_add_home_1637657110163|37"
        };
      case t("nav.treeDiagram"):
        return {
          btnIcon: "iconapp_ic_subtask",
          btnName: t("nav.treeDiagram"),
          clstag: "pageclick|keycount|xtbg_add_home_1637657110163|36"
        };
      case t("manageExternalModal.title"):
        return {
          btnName: t("manageExternalModal.title"),
          clstag: "pageclick|keycount|xtbg_add_home_1637657110163|59"
        };
      default:
        return { btnName: "", clstag: "" };
    }
  };

  return (
    <div className="address-content-header">
      {bigScreenTitle ? (
        <>
          <img className="address-content-header-img" src={icon_jzb} alt="" />
          <div className="address-content-header-title">{deptNavigation}</div>
          <div className="address-content-header-meeting">{creatMeeting}</div>
        </>
      ) : (
        <div className="address-content-header-title">{title}</div>
      )}
      <div className="switch_btn">
        {TabSwitchNode}
        {extra && (
          <>
            <Button
              className="address-nav-button"
              onClick={debounce(() => {
                extraClick?.();
              }, 200)}
              clstag={fileBtnClsTag(extra).clstag}
            >
              {fileBtnClsTag(extra).btnName}
            </Button>
            {!(window as any)?._BTS_CONFIG?.hideExtraManageExternal && extraManageExternalClick && (
              <Button
                className="address-nav-button"
                onClick={debounce(() => {
                  extraManageExternalClick?.();
                }, 200)}
                clstag={fileBtnClsTag(t("manageExternalModal.title")).clstag}
              >
                {t("manageExternalModal.title")}
              </Button>
            )}
          </>
        )}

        {handleSwitchClick && activeKey && (
          <>
            <Button
              className={activeKey === "org" ? "activeBtn btn" : "unActiveBtn btn"}
              onClick={() => {
                handleSwitchClick("org");
              }}
              clstag={fileBtnClsTag(t("nav.tile")).clstag}
            >
              {fileBtnClsTag(t("nav.tile")).btnIcon && (
                <IconFont type={fileBtnClsTag(t("nav.tile")).btnIcon} />
              )}
              {fileBtnClsTag(t("nav.tile")).btnName}
            </Button>
            <Button
              className={activeKey !== "org" ? "activeBtn btn" : "unActiveBtn btn"}
              onClick={() => {
                handleSwitchClick("tree");
              }}
              clstag={fileBtnClsTag(t("nav.treeDiagram")).clstag}
            >
              {fileBtnClsTag(t("nav.treeDiagram")).btnIcon && (
                <IconFont type={fileBtnClsTag(t("nav.treeDiagram")).btnIcon} />
              )}
              {fileBtnClsTag(t("nav.treeDiagram")).btnName}
            </Button>
          </>
        )}
      </div>
    </div>
  );
}

// title
export function useRightListTitle(addressNavKey: AddressNavKey | string): string {
  const { t } = useTranslation("addressList");
  const selectedItem = menuItems.find((item) => item.id === addressNavKey);
  if (!selectedItem) {
    return "";
  }
  return t(selectedItem.label);
}

export interface SearchGroup {
  realName: string;
  app: string;
  avatar: string;
  teamId: string;
  userId: string;
  pin: string;
  mobile: string;
  deptName: string;
}

export interface Tag {
  tagId: string;
  tagName: string;
}

export interface TagRes {
  tagId: string;
  name: string;
  sortNum: number;
}

export enum currentStatus {
  edit = "edit",
  creat = "creat",
  check = "check"
}

export enum tagType {
  hidden = "hidden",
  close = "close",
  open = "open"
}

export interface tagEmplPojoList {
  userId: string;
  teamId: string;
  appId: string;
}

// 联系人关系
export enum ContactShipType {
  COLLEAGUES = "colleagues", // 同事
  SELF = "self", // 自已
  FRIEND = "friend", // 好友关系 双向
  BLACKLIST = "blacklist", // 黑名单
  STRANGER = "stranger", // 陌生人
  FOLLOW = "follow", // 被关注 B好友列表有A，A好友列表没有B
  ONE_WAY = "one_way" // 单向好友 A好友列表有B   B好友列表没有A
}

// 添加联系人状态
export enum AddContactsState {
  INIT = "init", // 初始状态
  DONE = "done", // 已添加
  Applied = "applied" // 已申请
}

export function getContactShipType({
  relation,
  friendship
}: {
  relation: number;
  friendship: number;
}) {
  if (relation === 1) {
    return ContactShipType.COLLEAGUES; // 同事
  }
  if (relation === 2) {
    switch (friendship) {
      case 0:
        return ContactShipType.STRANGER; // 没有好友关系
      case 1:
        return ContactShipType.FRIEND; // 好友关系
      case 2:
        return ContactShipType.BLACKLIST; // 黑名单
      case 4:
        return ContactShipType.FOLLOW; // 被关注
      case 8:
        return ContactShipType.ONE_WAY; // 单向好友关系， 单相思
      default:
        return ContactShipType.STRANGER; // 没有好友关系
    }
  }
}

export function getAddContactsState({ contactShipType }: ListItemData) {
  if (contactShipType === ContactShipType.FRIEND || contactShipType === ContactShipType.ONE_WAY) {
    return AddContactsState.DONE;
  }
  return AddContactsState.INIT;
}

export function getUserCardActions({ contactsState }: ListItemData) {
  // 已添加好友以后 可以直接发起会话
  if (contactsState === AddContactsState.DONE) {
    return [UserCardAction.Chat];
  } else {
    // 未添加好友时， 显示添加联系人
    return [UserCardAction.Add];
  }
}

// // 人员选择器返回数据
// export function mapDetailListData(labelEmplPojoList: any) {
//     const imService = ImService.getInstance();
//     const currentEmployee = imService.getCurrentEmployee();
//     const detailList = labelEmplPojoList.map((item: any) => {
//         return {
//             ...item,
//             desc: getDeptPositionDesc(
//                 item?.e_dept_full_name,
//                 item?.e_position,
//                 item?.userId,
//                 currentEmployee
//             ),
//             labelInfoList: item?.labelInfoList || [],
//         };
//     });
//     return detailList;
// }

export function mapEbookSimpleDetailList(dataList: any) {
  return (dataList || []).map((item: any) => {
    let fields: any = {};
    (item.fields || []).forEach((fieldItem: any) => {
      fields[fieldItem.key] = fieldItem.val;
    });
    return {
      id: `${item.userId}:${item.appId}:${item.teamId}`,
      appId: item.appId,
      app: item.appId,
      avatar: changeEgovUrl(fields["avatar"]) || "",
      name: fields["name"] || "",
      userId: item.userId,
      nickName: fields["name"] || "",
      realName: item?.realName || "",
      teamId: item.teamId,
      desc: getDeptPositionDesc({
        deptName:
          fields["e_dept_full_name"] ||
          fields["deptName"] ||
          item.partTimeTitleDeptInfo?.[0]?.deptName ||
          "",
        titleName:
          fields["e_position"] ||
          fields["titleName"] ||
          item.partTimeTitleDeptInfo?.[0]?.titleName ||
          "",
        unitName: item.partTimeTitleDeptInfo?.[0]?.unitName || "",
        userType: item.userType
      }),
      labelInfoList: item?.labelInfoList || [],
      pin: item.userId,
      sessionId: item.sessionId || "",
      sessionType: 1,
      settings: {},
      origin: {
        info: { app: item.appId, userId: item.userId, teamId: item.teamId },
        uid: { pin: item.userId, app: item.appId, teamId: item.teamId }
      },
      unitName: item.partTimeTitleDeptInfo?.[0]?.unitName || "",
      deptName: item.partTimeTitleDeptInfo?.[0]?.deptName || "",
      titleName: item.partTimeTitleDeptInfo?.[0]?.titleName || "",
      deptId: item.partTimeTitleDeptInfo?.[0]?.deptId,
      unitDeptId: item.partTimeTitleDeptInfo?.[0]?.unitDeptId,
      userType: item.userType,
      remark: item.remark
    };
  });
}

/**
 * 合并与联系有用户关系数据
 * @param contacts
 * @param ships
 */
export function mergeContactShip(contacts: ListItemData[], ships: any) {
  for (let ship of ships) {
    const id = `${ship?.pin}:${ship?.app}:${ship?.teamId}`;
    const index = contacts.findIndex((item) => item.id === id);
    if (index > -1) {
      contacts[index].relation = ship.relationship.relation;
      contacts[index].friendship = ship.relationship.friendship;
      contacts[index].contactShipType = getContactShipType({ ...ship.relationship });
      contacts[index].contactsState = getAddContactsState(contacts[index]);
    }
  }
  return contacts;
}

/**
 * 映射搜索联系人结果, 同时 去掉和自已相同 teamId app的用户
 * @param searchContactResult 联系人搜索结果
 * @param userInfo
 */
export function mapSearchContact(
  searchContactResult: any,
  userInfo: { teamId: string; app: string; userId: string }
): ListItemData[] {
  return searchContactResult.reduce((result: ListItemData[], item: any): ListItemData[] => {
    result.push({
      id: `${item.userId}:${item.app}:${item.teamId}`,
      name: item.realName,
      app: item.app,
      avatar: item.avatar || "",
      teamId: item.teamId,
      userId: item.userId,
      pin: item.userId,
      mobile: item.mobile,
      teamName: item.teamName,
      desc: item.teamName,
      labelInfoList: item?.labelInfoList || []
    });
    return result;
  }, []);
}

export function mapSearchGroup(searchGroupResult: any): ListItemData {
  return {
    id: searchGroupResult.groupId,
    name: searchGroupResult.groupName,
    app: searchGroupResult.app,
    avatar: searchGroupResult.avatar || "",
    kind: searchGroupResult.kind,
    subKind: searchGroupResult.subKind,
    business: searchGroupResult.business,
    owner: searchGroupResult.owner || {}
  };
}

export function mapNewContacts(newContacts: Apply[]): ListItemData[] {
  return newContacts.map(
    (item): ListItemData => {
      const data = {
        ...item,
        id: item.id,
        name: item?.name || "",
        app: item.app,
        avatar: item.headImage || "",
        teamId: item.teamId,
        userId: item.userId || item.pin,
        pin: item.userId || item.pin,
        desc: item.info || last(item.items)?.info || "",
        // labelInfoList: item?.labelInfoList || [],
        applyInfos: item?.items?.length > 0 ? (item.items || []).slice(0, 3) : [item],
        status: item.status,
        labelId: item.labelId,
        applyTime: item.applyTime,
        timestamp: item.timestamp
      };
      // 我发送的数据展示接受收者的用户信息
      if (item.isSelfSend === 1) {
        return {
          ...data,
          ...item.receiver,
          name: item?.receiver?.realName || "",
          remark: ""
        };
      } else {
        return {
          ...data,
          ...item.userEbooks,
          name: item?.userEbooks?.realName || "",
          remark: ""
        };
      }
    }
  );
}

export async function mapLabelContacts(externalContacts: ListItemData[]) {
  const imService = ImService.getInstance();
  const currentEmployee = await imService.getCurrentEmployee();
  return externalContacts.reduce((result: ListItemData[], item: ListItemData): ListItemData[] => {
    // 去掉同租户，同团队
    const index = result.findIndex((listItem) => {
      return `${item.id}` === `${listItem.userId}:${listItem.app}:${listItem.teamId}`;
    });
    if (index > -1) {
      return result;
    }
    result.push({
      id: item.id,
      name: item.name,
      app: item.app,
      avatar: item.avatar || "",
      teamId: item.teamId,
      userId: item.userId,
      pin: item.userId,
      // desc: item.employee.station,
      desc: getDeptPositionDesc({
        deptName: item?.e_dept_full_name || item?.deptName,
        titleName: item?.e_position || item?.titleName,
        userId: item?.userId,
        currentEmployee: currentEmployee,
        userType: item.userType || ""
      }),
      labelInfoList: item?.labelInfoList || []
    });
    return result;
  }, []);
}

export async function mapExternalContacts(
  externalContacts: Friend[],
  userInfo?: { teamId: string; app: string }
) {
  const imService = ImService.getInstance();
  const currentEmployee = await imService.getCurrentEmployee();
  return externalContacts.reduce((result: ListItemData[], item: Friend): ListItemData[] => {
    // 去掉同租户，同团队
    const index = result.findIndex((listItem) => {
      return `${item.id}` === `${listItem.userId}:${listItem.app}:${listItem.teamId}`;
    });
    const employeeExt = item.employee?.employeeExt || {};
    const userType = setUserTypeChange(
      { ...item?.employee, userType: employeeExt.userType },
      currentEmployee
    );
    if (index > -1) {
      return result;
    }
    result.push({
      id: item.id,
      name: item?.employee?.name || "",
      realName: item?.employee?.name || "",
      app: item.app || item?.employee?.app,
      avatar: item.employee.avatar || "",
      teamId: item.teamId || item?.employee?.teamId,
      userId: item.userId || item?.employee?.userId,
      pin: item.userId || item?.employee?.userId,
      accountType: item.employee.accountType,
      // desc: item.employee.station,
      desc: getDeptPositionDesc({
        deptName: item?.employee?.e_dept_full_name || item?.employee?.deptName || "",
        titleName: item?.employee?.e_position || item?.employee?.titleName || "",
        userId: item?.employee?.userId,
        currentEmployee: currentEmployee,
        unitName: item?.employee?.unitName || "",
        userType
      }),
      labelInfoList: item.employee?.labelInfoList || [],
      userType,
      remark: employeeExt.remark
    });
    return result;
  }, []);
}

export function getTreeList(
  deptInfo: EBookDeptInfoRes,
  isVirtualOrg: boolean,
  selectedEbookId: string
) {
  let ebookUsers;
  if (!isVirtualOrg) {
    ebookUsers = mapEbookUsers(deptInfo?.ebookInfoResList || [], undefined, selectedEbookId);
  } else {
    const rootOrgId = deptInfo?.simpleDeptInfoList[0]?.deptId;
    ebookUsers = mapEbookUsers(deptInfo?.ebookInfoResList || [], rootOrgId);
  }
  let ebookDeptInfoList = mapEbookSubDeptInfoList(deptInfo?.ebookSubDeptInfoList || []);
  let ebookList = ebookUsers.concat(ebookDeptInfoList).map((item, index) => {
    return {
      ...item,
      key: item.isLeaf ? v4() : item.id
    };
  });

  return ebookList || [];
}

export function getWorkLineTreeList(workLineInfo: ebookWorkLineInfo, selectedEbookId: string) {
  let ebookUsers = mapEbookUsers(
    workLineInfo?.emplList || [],
    undefined,
    selectedEbookId,
    "workLine"
  );
  let ebookWorkLineInfoList = mapEbookSubDeptInfoList(workLineInfo?.subNodeList || []);
  let ebookList = ebookUsers.concat(ebookWorkLineInfoList).map((item, index) => {
    return {
      ...item,
      key: item.isLeaf ? v4() : item.id
    };
  });

  return ebookList || [];
}

export function firstUpdateTreeList(simpleDeptInfo: any) {
  if (!simpleDeptInfo) {
    return [];
  }
  return simpleDeptInfo?.map((item: any) => {
    if (!item) {
      return {};
    }
    return {
      ...item,
      id: item?.unitDeptId || item?.deptId || item.nodeId,
      key: item?.unitDeptId || item?.deptId || item.nodeId,
      name: item?.unitName || item?.deptName || item?.name,
      title: item?.unitName || item?.deptName || item?.name,
      isLeaf: false,
      desc: "",
      avatar: "",
      nodeId: item?.nodeId
    };
  });
}

// eslint-disable-next-line max-params
export function mapUserDetailTarget(
  list: any[],
  currentUserData: any,
  groupList?: any[],
  fullName?: string
) {
  return (
    // eslint-disable-next-line complexity
    list?.map((item: any, index: number) => {
      const name = item?.name || item?.realName || item?.memberName || "";
      const fullDeptName = item.fullDeptName || fullName || "";
      const memberType = item.memberType ? item.memberType : item?.terminalId ? 2 : 1;
      const titleName = item.titleName || item.positionName || "";
      return {
        ...item,
        userId: item?.userId || item?.terminalId || item?.memberId,
        appId: currentUserData?.app || currentUserData?.appId || "",
        teamId: currentUserData?.teamId || "",
        fields: item?.fields
          ? item?.fields
          : [
              {
                key: "name",
                val: titleName ? titleName + "-" + name : name,
                hide: 0,
                index: 2,
                name: "姓名"
              },
              {
                key: "avatar",
                val: item?.avatar || "",
                hide: 0,
                index: 0,
                name: "头像"
              }
            ],
        name: name,
        partTimeTitleDeptInfo:
          item?.partTimeTitleDeptInfo?.length > 0
            ? item?.partTimeTitleDeptInfo
            : [
                {
                  fullDeptName: fullDeptName
                  //   titleName:
                  //       (item.titleName || item.positionName) === '暂未填写'
                  //           ? '-'
                  //           : titleName,
                }
              ],
        memberType: memberType,
        groupList: item.groupList || groupList?.[index]?.groupList || [],
        labelInfoList: []
      };
    }) || []
  );
}

// eslint-disable-next-line max-params
export function mapEbookUsers(
  users: EBookDeptUserInfo[] | EmplListInfo[],
  rootOrgId?: string,
  deptId?: string,
  type?: string
): ListItemData[] {
  const data: any = users;
  return data.map(
    (user: any): ListItemData => {
      if (user.avatar) {
        user.avatar = getHeadImgThumbUrl(user.avatar, 150, 150);
      }
      let desc = user.positionName;
      if (type === "workLine") {
        if (user.unitName && user.deptName) {
          if (user.unitName === user.deptName) {
            desc = `${user.deptName}-${user.positionName}`;
          } else {
            desc = `${user.unitName}-${user.deptName}-${user.positionName}`;
          }
        }
      }

      return {
        id: `${user.userId}:${user.appId}:${user.teamId}`,
        app: user.appId,
        userId: user.userId,
        teamId: user.teamId,
        name: user.realName,
        accountType: user.accountType,
        title: user.realName,
        avatar: user.avatar || "",
        desc: desc,
        rootOrgId: rootOrgId || "",
        deptId: deptId || "",
        nodeId: user.nodeId || "",
        isLeaf: true,
        isLeader: user.isLeader || "",
        administratorType: user.administratorType || "",
        key: v4(),
        labelInfoList: user.labelInfoList,
        appId: user.appId
      };
    }
  );
}

export function openUserCardModal(
  contact: ListItemData & {
    needMask?: boolean;
    needMaskName?: boolean;
    robotId?: string;
    flag?: number;
    reply?: number;
  },
  actions?: UserCardAction[],
  deptId?: string
) {
  const {
    userId,
    teamId,
    app: appId,
    rootOrgId,
    type,
    needMask,
    needMaskName,
    robotId,
    flag,
    reply,
    id: applyId,
    isCanReply
  } = contact;
  Bus.emit("app:toggle-user-card-modal:show", {
    visible: true,
    type: type || UserCardType.User,
    userId,
    teamId,
    appId,
    rootOrgId,
    applyInfos: (contact?.applyInfos || []).map((item: any) => item).slice(0, 3),
    actions,
    deptId,
    needMask,
    needMaskName,
    robotId,
    flag,
    reply,
    applyId,
    isCanReply
  });
}

export function openGroupCardModal(group: ListItemData, actions?: UserCardAction[]) {
  Bus.emit("app:toggle-user-card-modal:show", {
    visible: true,
    appId: group.app,
    type: UserCardType.Group,
    group: group,
    applyInfos: (group.applyInfos || []).map((item: any) => item).slice(0, 3),
    actions
  });
}

export interface letterItemsMap {
  [key: string]: ListItemData[];
}

const letters = "*abcdefghijklmnopqrstuvwxyz#".split("");

export function groupListItem(list: ListItemData[]): letterItemsMap {
  if ((list || []).length === 0) {
    return {};
  }
  // eslint-disable-next-line @typescript-eslint/no-require-imports
  let { pinyin } = require("pinyin-pro");

  const letterItemsMap: letterItemsMap = letters.reduce((result: letterItemsMap, letter) => {
    result[letter] = [];
    return result;
  }, {});

  // for (let item of list) {
  //     const pinName = pinyin.getCamelChars(item.name).toLowerCase();
  //     let letter = pinName.charAt(0);
  //     if (!letters.includes(letter)) {
  //         letter = '#';
  //     }
  //     if (letterItemsMap.hasOwnProperty(letter)) {
  //         letterItemsMap[letter].push(item);
  //     } else {
  //         letterItemsMap[letter] = [item];
  //     }
  // }
  const newList: any = list.map((item: any) => {
    return {
      ...item,
      // pinName: pinyin.getFullChars(item.name).toLowerCase()
      pinName: pinyin(item.name).toLowerCase()
    };
  });

  newList.sort((a: any, b: any) => a.pinName.localeCompare(b.pinName, "zh")); // a~z 排序

  for (let item of newList) {
    let letter = item.pinName.charAt(0);
    if (!letters.includes(letter)) {
      letter = "#";
    }
    if (letterItemsMap.hasOwnProperty(letter)) {
      letterItemsMap[letter].push(item);
    } else {
      letterItemsMap[letter] = [item];
    }
  }

  // 去掉值为空数组的项
  return omitBy(letterItemsMap, isEmpty);
}

export function LetterHeader({ title }: { title: string }) {
  return (
    <div className="addressListItemGroupHeader" id={`letter_${title}`}>
      {title.toUpperCase()}
    </div>
  );
}

export function HeaderPreviewer({ letters }: { letters: string[] }) {
  const letterClick = (letter: string) => {
    const ele = document.getElementById(`letter_${letter}`);
    if (ele) {
      ele.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest"
      });
    }
  };
  return (
    <div className="addressListHeaderPreviewer">
      <div>
        {letters.map((letter) => {
          return (
            <div
              key={letter}
              // onMouseDown={letterClick.bind(null, letter)}
              onClick={letterClick.bind(null, letter)}
            >
              {letter.toUpperCase()}
            </div>
          );
        })}
      </div>
    </div>
  );
}

export async function getExternalContacts(userInfo?: {
  teamId: string;
  userId: string;
  app: string;
}): Promise<ListItemData[] | null> {
  try {
    const imService = ImService.getInstance();
    const externalContacts = await imService.getExternalContacts();
    if (!externalContacts) {
      return null;
    }
    return mapExternalContacts(externalContacts, userInfo);
  } catch (e) {
    return null;
  }
}

export async function getNewContacts(): Promise<ListItemData[] | null> {
  try {
    const imService = ImService.getInstance();
    const newContacts = await imService.getNewContacts();
    if (!newContacts) {
      return null;
    }
    if (!newContacts.length) {
      return [];
    }
    return mapNewContacts(newContacts);
  } catch (e) {
    return null;
  }
}

/**
 * 判断是不是跨平台
 */
export function isOuterApp(user: any, currentEmployee: any) {
  if (user) {
    return (user.app || user.appId) !==
      (currentEmployee.app || currentEmployee.appId || currentEmployee.ddAppId)
      ? true
      : false;
  }
  return false;
}

export function mapGetEbookDeptInfoList(memberIds: string[]) {
  try {
    const result = gatewayInstance.request({
      api: "screen.queryGroupListBatch",
      method: "POST",
      // @ts-ignore
      body: { memberIds: memberIds }
    });
    return result;
  } catch (error) {
    return null;
  }
}
export async function appliesNewContacts(user?: UID): Promise<ListItemData[] | null> {
  try {
    const imService = ImService.getInstance();
    const newContacts = await imService.getAppliesNewContacts(user);
    if (!newContacts) {
      return null;
    }
    if (!newContacts.length) {
      return [];
    }
    return newContacts;
  } catch (e) {
    return null;
  }
}

export async function getEbookDeptInfoList(payload: {
  orgId?: string;
  appId?: string;
  deptId?: string;
  displaySubDept?: boolean;
  orgTree?: string;
}): Promise<any> {
  let res = null;
  if (payload.orgId) {
    try {
      res = await getEbookOrgInfo(payload);
    } catch (e) {
      console.error(e);
    }
  } else {
    const imService = ImService.getInstance();
    res = await imService.getDeptInfo(payload);
  }
  return res || null;
}

export async function getWorkLineInfoList(payload: GetEbookWorkLineReq): Promise<any> {
  try {
    const imService = ImService.getInstance();
    let res = await imService.getWorkLineInfo(payload);
    return res || null;
  } catch (error) {
    console.error(error);
  }
}

export function mapEbookGroups(groups: EGroupGroupInfo[]): ListItemData[] {
  return (groups || []).map((group: any) => {
    if (group.avatar) {
      group.avatar = getHeadImgThumbUrl(group.avatar, 150, 150);
    }
    const { gid, name, avatar, rosterSize } = group;
    return {
      id: gid,
      name,
      avatar,
      desc: `${rosterSize} ${i18n.t("addressList:people")}`,
      origin: group
    };
  });
}

export function mapMyProjects(projects: Project[]): ListItemData[] {
  return projects.map((project: Project) => {
    const { projectId, name, icon } = project;
    return {
      id: projectId.toString(),
      name,
      avatar: icon,
      desc: ""
    };
  });
}

export async function sortGroupList(groupList: ListItemData[]) {
  const imService = ImService.getInstance();
  const { allSessionList } = await imService.loadSessionPageList({}, false, {
    sessionType: 2
  });
  const groupSessionList: any[] = allSessionList
    .filter((ele: any) => ele.isGroup && !ele.isNotice && !ele.isSecret)
    .map((i: any) => i.id)
    .reverse();
  groupList.sort((a, b) => groupSessionList.indexOf(b.id) - groupSessionList.indexOf(a.id));

  return groupList;
}

// ebookType '1' 我创建的    '2' 我加入的
export async function getEbookGroups({
  ebookType,
  pageInfo,
  allSessionList
}: {
  ebookType: string;
  pageInfo?: {
    cache?: boolean;
    page: number;
    pageSize: number;
  };
  allSessionList?: any;
}): Promise<ListItemData[] | null> {
  try {
    const data = await ImService.getInstance().getGroupList({
      ebookType,
      pageInfo,
      allSessionList
    });
    return mapEbookGroups(data);
  } catch (e) {
    console.error(e);
    return null;
  }
}

export function mapEbookSubDeptInfoList(
  ebookSubDeptInfoList: EBookSubDeptInfo[] | NodeListInfo[]
): ListItemData[] {
  const data: any = ebookSubDeptInfoList;
  return data.map((item: any) => {
    const { deptId, deptName, name, nodeId, contactNumber } = item;
    // console.log("mapData:", item);
    const desc = contactNumber ? `${contactNumber}${i18n.t("addressList:people")}` : "";
    return {
      id: deptId || nodeId,
      name: deptName || name,
      desc: desc,
      // avatar: deptId ? IconDefualtOrg : IconDefualtWorkLine,
      avatar: deptId ? default_dept_avatar : default_virtual_avatar,
      isLeaf: false,
      title: deptName || name,
      key: deptId || nodeId,
      nodeId
    };
  });
}

export function acceptFriend({
  user,
  status,
  accessPhone,
  remark,
  acrossApp
}: {
  user: UID;
  remark: string;
  status: RosterApplyStatus;
  accessPhone?: string;
  acrossApp?: boolean;
}) {
  const imService = ImService.getInstance();
  return imService.confirmFriendApply({ remark, user, status, accessPhone, acrossApp });
}

export function getOrgActive(addressNavKey: AddressNavKey | string, deptId?: string) {
  return addressNavKey === `${AddressNavKey.ORG}-${deptId}`;
}

export function getWorkLIneActive(addressNavKey: AddressNavKey | string, nodeId?: string) {
  return addressNavKey === `${AddressNavKey.WORK_LINE}-${nodeId}`;
}

export function getWorkLineId(data: GetEbookWorkLineReq) {
  return data?.nodeId;
}

// 人员标签属性展示 （未认证、外部、单位领导、管理员等）
export function tagsNode(labelInfoList: labelInfoList[] | EmployeeLabel[]) {
  return labelInfoList?.map((label: labelInfoList, key: number) => {
    return label.isShow === "1" ? (
      <span
        key={key}
        className="user-tags"
        style={{
          color: `#${label.color}`,
          background: `#${label.color}10`
        }}
      >
        {label.name}
      </span>
    ) : null;
  });
}

export interface ILable {
  name: string;
  color: string;
}

export function tagsNodeSimple(labelInfo: ILable) {
  return (
    <span
      className="user-tags"
      style={{
        color: `#${labelInfo.color}`,
        background: `#${labelInfo.color}10`
      }}
    >
      {labelInfo.name}
    </span>
  );
}

export async function setClientCurrentEmployee(params: any) {
  const imService = ImService.getInstance();
  const user: any = await imService.getClientUser(params);
  let fields: UserCardItem[] = [];
  fields.push({
    key: "mobile",
    val: user.mobile,
    hide: 0,
    name: "手机",
    index: 0
  });
  fields.push({
    key: "email",
    val: user.email,
    hide: 0,
    name: "邮箱",
    index: 1
  });
  // fields.push({
  //   key: "cardNumber",
  //   val: user.cardNumber,
  //   hide: 0,
  //   name: "北京通号",
  //   index: 2
  // });
  fields.push({
    key: "name",
    val: user.name,
    hide: 0,
    name: "姓名",
    index: 3
  });
  fields.push({
    key: "avatar",
    val: user.avatar,
    hide: 0,
    name: "头像",
    index: 4
  });
  return { partTimeTitleDeptInfo: [user], fields, ...user };
}
